import { get, post, put, del } from 'utils/methods';

export function loadPlanningApi(data, headers) {
    return get(`${process.env.REACT_APP_REST_PP}machine-planned-time`, data, headers);
}

export function planFormVersionApi(data, headers) {
    return post(`${process.env.REACT_APP_REST_PP}commands/form-version`, data, headers);
}

export function editFormVersionApi(data, headers) {
    return put(`${process.env.REACT_APP_REST_PP}commands/form-version`, data, headers);
}

export function simulatePlanningFormVersionApi(data) {
    return get(`${process.env.REACT_APP_REST_PP}verify-form-versions`, data);
}

export function addReservationApi(data, headers) {
    return post(`${process.env.REACT_APP_REST_PP}commands/machine/reservation`, data, headers);
}

export function deleteReservationApi(data, headers) {
    return del(`${process.env.REACT_APP_REST_PP}commands/machine/reservation`, data, headers);
}

export function movePlanningApi(data, headers) {
    return post(`${process.env.REACT_APP_REST_PP}commands/move-planning`, data, headers);
}

export function verifyMultipleFormVersionsApi(data, headers) {
    return post(`${process.env.REACT_APP_REST_PP}verify-multiple-form-versions`, data, headers);
}

export function planBulkFormVersionsApi(data, headers) {
    return post(`${process.env.REACT_APP_REST_PP}commands/grouped-form-version`, data, headers);
}
